import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import { categories } from "@/mocks/categories";
import { formatViews } from "@/lib/video";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickEntry from "./components/CategoryQuickEntry";
import VideoSection from "./components/VideoSection";

const featuredIds = ["v16", "v21", "v11", "v6", "v1"];

export default function Home() {
  const featured = featuredIds
    .map((id) => videos.find((v) => v.id === id))
    .filter((v): v is (typeof videos)[number] => Boolean(v));

  const latest = [...videos]
    .sort((a, b) => b.publishDate.localeCompare(a.publishDate))
    .slice(0, 8);

  const hot = [...videos]
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  const totalViews = videos.reduce((sum, v) => sum + v.views, 0);

  const stats = [
    { icon: "ri-video-line", value: `${videos.length}+`, label: "精选视频" },
    { icon: "ri-apps-2-line", value: `${categories.length}`, label: "内容分类" },
    { icon: "ri-fire-line", value: formatViews(totalViews), label: "累计播放" },
    { icon: "ri-refresh-line", value: "每日", label: "持续更新" },
  ];

  return (
    <div className="w-full">
      <section className="px-4 pt-10 md:px-6 md:pt-14">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-label text-secondary-900">
              <i className="ri-flashlight-fill text-primary-500"></i>
              每日精选更新的短视频合集
            </span>
            <h1 className="mt-4 font-heading text-3xl font-extrabold leading-tight text-foreground-950 md:text-5xl">
              日批视频 · 热门短视频平台合集
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              聚合全网最新、最热门的短视频内容，覆盖生活、美食、音乐、游戏、搞笑等多元类别。
              无论你想找点乐子还是发现新内容，都能在这里一次看个够。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/category/funny"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                <i className="ri-play-fill text-lg"></i>
                开始观看
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-label text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600"
              >
                了解平台
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 lg:w-auto">
            {stats.map((s) => (
              <div
                key={s.label}
                className="flex flex-col gap-1 rounded-lg border border-background-200 bg-background-100 p-4 lg:w-36"
              >
                <i className={`${s.icon} text-xl text-primary-500`}></i>
                <span className="font-heading text-xl font-extrabold text-foreground-950">
                  {s.value}
                </span>
                <span className="text-xs text-foreground-500">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <HeroCarousel videos={featured} />

      <CategoryQuickEntry />

      <VideoSection
        title="最新发布"
        subtitle="按发布时间为你排序，第一时间看到新鲜短视频"
        icon="ri-time-line"
        videos={latest}
        viewAllTo="/search"
        viewAllLabel="浏览更多"
      />

      <VideoSection
        title="热门榜"
        subtitle="依据播放量与点赞数综合筛选的高热度内容"
        icon="ri-fire-line"
        videos={hot}
        viewAllTo="/category/funny"
        viewAllLabel="浏览更多"
      />

      <section className="px-4 pt-12 md:px-6 md:pt-16">
        <div className="flex flex-col gap-6 rounded-lg border border-background-200 bg-accent-100 p-6 md:flex-row md:items-center md:justify-between md:p-10">
          <div className="max-w-2xl">
            <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
              关于日批视频
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              日批视频是一个面向年轻用户的短视频聚合平台。我们持续收录最新、最热门的短视频，
              按分类整理并每日更新，帮你更高效地发现喜欢的内容。平台只做内容聚合与观看，
              全部视频信息为演示数据。
            </p>
          </div>
          <Link
            to="/about"
            className="inline-flex w-fit shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            了解更多
            <i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        </div>
      </section>
    </div>
  );
}